<template>
  <v-autocomplete
    class="custom-autocomplete"
    v-model="model"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    item-text="name"
    item-value="id"
    :label="$t(title)"
    :multiple="multiple"
    chips
    dense
    outlined
    clearable
    no-filter
    return-object
    append-icon=""
    :error="error"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title class="product-name">
          {{ item.name }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:selection="{ item, index }">
      <template v-if="multiple">
        <v-chip
          v-if="index < 1"
          close
          small
          class="product-chip ellipsis-chip"
          color="primary"
          dark
          @click:close="remove(item)"
        >
          {{ item.name }}
        </v-chip>

        <v-chip v-else-if="index === 1" small class="other-chip">
          + {{ model.length - 1 }} {{ $t("other") }}
        </v-chip>
      </template>
      <template v-else>
        <span class="single-selection-text ellipsis-chip">
          {{ item.name }}
        </span>
      </template>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>
            {{ search ? $t("no-data") : $t("typeToSearch") }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-slot:append-item>
      <div
        v-if="hasMore"
        v-observe-visibility="visibilityChanged"
        class="text-center py-2"
      >
        <v-progress-circular indeterminate size="18" width="2" color="primary" />
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";

export default {
  name: "ProductAutocomplete",

  props: {
    value: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      default: "product",
    },
    currency: {
      type: [String, Number],
      default: null,
    },
    fetchData: {
      type: Function,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "is-required",
    },
  },

  data() {
    return {
      items: [],
      search: "",
      loading: false,
      page: 1,
      perPage: 10,
      hasMore: true,
    };
  },

  computed: {
    model: {
      // get() {
      //   return this.value;
      // },
      // set(val) {
      //   this.$emit("input", val);
      // },
      get() {
        if (!this.multiple && Array.isArray(this.value)) {
          return this.value.length > 0 ? [this.value[0]] : [];
        }
        return this.value;
      },
      set(val) {
        if (!this.multiple && Array.isArray(val)) {
          this.$emit("input", val.length > 0 ? [val[val.length - 1]] : []);
        } else {
          this.$emit("input", val);
        }
      },
    },
  },

  watch: {
    search: debounce(function () {
      this.reset();
      this.fetchAPI();
    }, 400),
  },

  mounted() {
    if (this.value?.length) {
      this.items = [...this.value];
    }
    this.fetchAPI();
  },

  methods: {
    reset() {
      this.page = 1;
      this.items = [];
      this.hasMore = true;
    },

    fetchAPI() {
      if (this.loading || !this.hasMore) return;

      var app = this;
      app.loading = true;
      app
        .fetchData({
          page: app.page,
          search: app.search,
          type: app.type,
        })
        .then(function (result) {
          let list = result.items || [];

          list.forEach(function (item) {
            if (
              !app.items.some(function (p) {
                return p.id === item.id;
              })
            ) {
              app.items.push(item);
            }
          });

          app.hasMore = result.hasMore;
          if (app.hasMore) {
            app.page++;
          }
        })
        .finally(function () {
          app.loading = false;
        });
    },

    visibilityChanged(visible) {
      if (visible) {
        this.fetchAPI();
      }
    },

    remove(item) {
      if (this.multiple) {
        this.model = this.model.filter(function (p) {
          return p.id !== item.id;
        });
      } else {
        this.model = [];
      }
    },
  },
};
</script>
<style scoped>
.v-autocomplete {
  direction: rtl;
}
.product-name {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.ellipsis-chip {
  max-width: 75px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: right;
}
</style>
